import React from "react";
import { Link, NavLink } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import { Container } from "react-bootstrap";

const GoatFightHeader = () => {
    return (

            <header className="site-header shell">
                <Link className="brand" to="/">
                    <img src={logo} alt="Goat Fight" />
                </Link>

                <nav className="main-nav" aria-label="Primary">
                    <NavLink to='/' end>HOME</NavLink>
                    <NavLink to='/nba'>NBA</NavLink>
                    <NavLink to='/golf'>GOLF</NavLink>
                    <a href='/#how-it-works'>HOW IT WORKS</a>
                </nav>

                <div className="header-actions">
                    <Link className="btn btn-outline" to="/login">
                        LOGIN
                    </Link>

                    <Link className="btn btn-primary" to="/signup">
                        JOIN NOW
                    </Link>

                    <span aria-label="Account" className="avatar-img">
                        <i className="fa fa-user-circle" aria-hidden="true"></i>
                    </span>
                </div>
            </header>
    );
};

export default GoatFightHeader;




